const storeLink = {
  name: 'common.header.allProducts',
  href: '/store/products',
  isTranslationKey: true,
};

export const storeLinks = [storeLink];
